module.exports = __webpack_public_path__ + "img/property_5_vista.b6e3a076.jpg";